<script setup lang="ts">
const properties = withDefaults(
  defineProps<{
    angle?: 'left' | 'right'
    background?: string
    foreground?: string
  }>(),
  {
    angle: 'left',
    background: 'white',
    foreground: 'sunglow-500',
  },
)

const container = ref<HTMLElement>()

const containerHeight = ref(0)
const calculateHeight = (width: number) => {
  const angleInDegrees = 5
  return Math.ceil(width * Math.tan((angleInDegrees * Math.PI) / 180))
}

const ANGLE_CLASSES = {
  left: 'angle-left',
  right: 'angle-right',
}

const angleClass = computed(() => {
  return ANGLE_CLASSES[properties.angle]
})

onMounted(() => {
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const { width } = entry.contentRect
      containerHeight.value = calculateHeight(width)
    }
  })

  if (container.value) {
    resizeObserver.observe(container.value)
  }

  onBeforeUnmount(() => {
    resizeObserver.disconnect()
  })
})
</script>

<template>
  <div
    :style="{
      '--background': `var(--color-${properties.background})`,
      height: `${containerHeight || 100}px`,
      overflowX: 'clip',
      overflowY: 'visible',
    }"
    class="relative w-full bg-[--background]"
    ref="container"
  >
    <div
      :class="angleClass"
      :style="{
        '--foreground': `var(--color-${properties.foreground})`,
      }"
      class="absolute inset-x-0 inset-y-[-1px] bg-[--foreground]"
    ></div>
  </div>
</template>

<style lang="css">
.angle-left {
  clip-path: polygon(100% 0, 0 100%, 100% 100%);
}

.angle-right {
  clip-path: polygon(0 100%, 0 0, 100% 100%);
}
</style>
